import { useCallback } from 'react';

import { IEventRound } from '../../../store/admin/eventRounds/store';
import { IEventRound as IPlayerEventRound, IEventsStore } from '../../../store/player/events/store';

import { IAdminEventsStore } from '../../../store/admin/events/store';

export const useGetRoundLabel = (
  events: IEventsStore | IAdminEventsStore,
  eventId: number,
  roundId: number | undefined
) => {
  const getRoundLabel = useCallback(() => {
    if (roundId && events[eventId]) {
      const roundIndex = events[eventId].rounds.findIndex(
        (round: IEventRound | IPlayerEventRound) => String(round.id) === String(roundId)
      );

      return `R${roundIndex >= 0 ? roundIndex + 1 : ''}`;
    } else {
      return 'T';
    }
  }, [events, eventId, roundId]);

  return [getRoundLabel];
};
